import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import Button from "../buttons/button"

const Section = styled.section`
  background-color: #6C7E99;
  position: relative;

  > .gatsby-image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
`

const Inner = styled.div`
  position: relative;
  z-index: 2;
  padding: 5rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Heading = styled.h2`
  color: #fff;
  font-size: clamp(2.5rem, 1.6176rem + 2.3529vw, 3.5rem);
`

const CTA = styled(Button)`
  padding: 1rem 2rem;
  border: 1px solid #24293C;
  margin-top: 2rem;
  font-size: 1.25rem;
  transition: all 300ms;

  &:hover,
  &:focus {
    background: #fff;
    color: #24293C;
  }
`

const BottomCTA = () => {

  const data = useStaticQuery(graphql`
    query GetStarted {
      # selecting the current post by id
      fields: wpPage(isFrontPage: { eq: true }) {
        footerSettingsFields {
          bottomCta {
            heading
            button {
              label
              url
            }
          }
        }
      }
    }
    `)

  const bottomCta = data.fields.footerSettingsFields.bottomCta;

  return (
    <Section>
      <StaticImage src="../../images/reset/reset-hero-bg.png" alt="" objectFit="cover" />
      <Inner>
        <Heading>
          {bottomCta.heading}
        </Heading>
        <CTA to={bottomCta.button.url}>
          {bottomCta.button.label}
        </CTA>
      </Inner>
    </Section>
  )
}

export default BottomCTA
